export default [
    {
        key: "standard_favicons",
        title: "Standard Favicons",
        labels: [
            "16x16: Classic favicon for most browsers",
            "32x32: For high-DPI displays",
            "48x48: Windows site icons",
            "64x64: Higher resolution for Windows site icons",
        ],
        sizes: [
            16,
            32,
            48,
            64,
        ]
    },
    {
        key: "web_app_manifest",
        title: "Web App Manifest (PWA)",
        labels: [
            "192x192: Home screen icon on Android",
            "512x512: Splash screen icon on Android"
        ],
        sizes: [
            192,
            512,
        ] 
    },
    {
        key: "additional_size_for_better_coverage",
        title: "Additional Sizes for Better Coverage",
        labels: [
            "128x128: Chrome Web Store icon",
            "196x196: Chrome for Android home screen icon",
            "228x228: Opera Coast icon"
        ],
        sizes: [
            128,
            196,
            228,
        ]
    },
    {
        key: "microsoft_windows",
        title: "Microsoft Windows",
        labels: [
            "70x70: Windows 10 small tile",
            "150x150: Windows 10 medium tile",
            "310x310: Windows 10 large tile",
            "310x150: Windows 10 wide tile",
        ],
        sizes: [
            70,
            150,
            310,
            310,
        ]
    },
    {
        key: "android_devices",
        title: "Android Devices",
        labels: [
            "36x36: Android devices with low-density screens (ldpi)",
            "48x48: Android devices with medium-density screens (mdpi)",
            "72x72: Android devices with high-density screens (hdpi)",
            "96x96: Android devices with extra-high-density screens (xhdpi)",
            "144x144: Android devices with extra-extra-high-density screens (xxhdpi)",
            "192x192: Android devices with extra-extra-extra-high-density screens (xxxhdpi)",
        ],
        sizes: [
            36,
            48,
            72,
            96,
            144,
            192,
        ]
    },
    {
        key: "apple_touch_icons",
        title: "Apple Touch Icons (iOS devices)",
        labels: [
            "57x57: iPhone (pre-retina)",
            "72x72: iPad (pre-retina)",
            "76x76: iPad mini and iPad (retina)",
            "114x114: iPhone (retina)",
            "120x120: iPhone 6 and later",
            "144x144: iPad (retina)",
            "152x152: iPad (3rd and 4th generation)",
            "180x180: iPhone 6 Plus and later",
        ],
        sizes:[
            57,
            72,
            76,
            114,
            120,
            144,
            152,
            180,
        ]
    },
];
